/** Installs `window.api` as a side effect of being imported. See renderer/src/web/entry.ts. */
import { installApi } from './api'

installApi()
